import { render, staticRenderFns } from "./work-index.vue?vue&type=template&id=6a5291dd&scoped=true"
import script from "./work-index.vue?vue&type=script&lang=js"
export * from "./work-index.vue?vue&type=script&lang=js"
import style0 from "./work-index.vue?vue&type=style&index=0&id=6a5291dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5291dd",
  null
  
)

export default component.exports